var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseVeeForm',{attrs:{"action":_vm.submitForm},on:{"success":_vm.onSuccess},scopedSlots:_vm._u([{key:"default",fn:function(formProps){return [_c('BaseCard',[_c('BaseCardBody',[_c('h3',{staticClass:"text-lg leading-6 font-medium text-gray-900"},[_vm._v("General Settings")])]),_c('BaseCardBody',[_c('BaseFormTextFieldWithValidator',{staticClass:"max-w-lg",attrs:{"disabled":formProps.isPending,"validator":{
            name: 'name',
            vid: 'name',
            rules: { required: true },
          },"field":{
            id: 'contact_list_name',
            label: 'Name',
          }},model:{value:(_vm.formData.name),callback:function ($$v) {_vm.$set(_vm.formData, "name", $$v)},expression:"formData.name"}})],1),_c('BaseCardFooter',{attrs:{"gray":""}},[_c('BaseButton',{attrs:{"primary":""}},[_vm._v(" Save ")])],1)],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }